var fn = function( obj ){
var __t,__p='';
__p+='precision lowp float;\n\nattribute vec2 aPosition;\n\nuniform mat4 uUnproject;\n\nvarying lowp vec3 vRaydir;\n\nvoid main( void ){\n  vec4 pos = vec4( aPosition, .5, 1.0 );\n  vRaydir = normalize( (uUnproject * pos).xyz );\n  gl_Position = pos;\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
